import React from 'react';

export function Brand({ compact = false }) {
  return (
    <div className={`brand ${compact ? 'brand--compact' : ''}`} aria-label="RowSprint">
      <div className="brand__mark" aria-hidden="true">
        <span>2</span><span>7</span><span>12</span>
      </div>
      <div>
        <strong>RowSprint</strong>
        {!compact && <small>Würfeln. Kreuzen. Reihen schließen.</small>}
      </div>
    </div>
  );
}
